import { send } from '../../../src/network';

export function postReactivateAccount() {
  return send<unknown>({
    path: '/api/reactivate_account/',
    method: 'POST',
    body: {},
  });
}
